import { Routes } from '@angular/router';

export const PROYECTOS_ROUTES: Routes = [
  {
    path: 'listar',
    loadComponent: () =>
      import('./listar/proyecto-listar.component')
        .then(m => m.ProyectoListarComponent)
  },
  {
    path: 'crear',
    loadComponent: () =>
      import('./crear/proyecto-crear.component')
        .then(m => m.ProyectoCrearComponent)
  },
  {
    path: 'editar/:id',
    loadComponent: () =>
      import('./editar/proyectos-editar.component')
        .then(m => m.ProyectosEditarComponent)
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./detalle/proyecto-detalle.component')
        .then(m => m.ProyectoDetalleComponent)
  },
  {
    path: 'gestion-financiera/:id',
    loadComponent: () =>
      import('./gestion-financiera/gestion-financiera')
        .then(m => m.GestionFinanciera)
  }
];
